export default [
    {
        "value": "Hong Kong",
        "en": "Hong Kong",
        "zh": "香港"
    },
    {
        "value": "China",
        "en": "China",
        "zh": "中國"
    },
    {
        "value": "Macau",
        "en": "Macau",
        "zh": "澳門"
    },
    {
        "value": "Afghanistan",
        "en": "Afghanistan",
        "zh": "阿富汗"
    },
    {
        "value": "Albania",
        "en": "Albania",
        "zh": "阿爾巴尼亞"
    },
    {
        "value": "Algeria",
        "en": "Algeria",
        "zh": "阿爾及利亞"
    },
    {
        "value": "Andorra",
        "en": "Andorra",
        "zh": "安道爾"
    },
    {
        "value": "Angola",
        "en": "Angola",
        "zh": "安哥拉"
    },
    {
        "value": "Antigua and Barbuda",
        "en": "Antigua and Barbuda",
        "zh": "安提瓜和巴布達"
    },
    {
        "value": "Argentina",
        "en": "Argentina",
        "zh": "阿根廷"
    },
    {
        "value": "Armenia",
        "en": "Armenia",
        "zh": "亞美尼亞"
    },
    {
        "value": "Australia",
        "en": "Australia",
        "zh": "澳大利亞"
    },
    {
        "value": "Austria",
        "en": "Austria",
        "zh": "奧地利"
    },
    {
        "value": "Azerbaijan",
        "en": "Azerbaijan",
        "zh": "阿塞拜疆"
    },
    {
        "value": "Bahamas",
        "en": "Bahamas",
        "zh": "巴哈馬"
    },
    {
        "value": "Bahrain",
        "en": "Bahrain",
        "zh": "巴林"
    },
    {
        "value": "Bangladesh",
        "en": "Bangladesh",
        "zh": "孟加拉國"
    },
    {
        "value": "Barbados",
        "en": "Barbados",
        "zh": "巴巴多斯"
    },
    {
        "value": "Belarus",
        "en": "Belarus",
        "zh": "白俄羅斯"
    },
    {
        "value": "Belgium",
        "en": "Belgium",
        "zh": "比利時"
    },
    {
        "value": "Belize",
        "en": "Belize",
        "zh": "伯利茲"
    },
    {
        "value": "Benin",
        "en": "Benin",
        "zh": "貝寧"
    },
    {
        "value": "Bhutan",
        "en": "Bhutan",
        "zh": "不丹"
    },
    {
        "value": "Bolivia",
        "en": "Bolivia",
        "zh": "玻利維亞"
    },
    {
        "value": "Bosnia and Herzegovina",
        "en": "Bosnia and Herzegovina",
        "zh": "波斯尼亞和黑塞哥維那"
    },
    {
        "value": "Botswana",
        "en": "Botswana",
        "zh": "博茨瓦納"
    },
    {
        "value": "Brazil",
        "en": "Brazil",
        "zh": "巴西"
    },
    {
        "value": "Brunei",
        "en": "Brunei",
        "zh": "文萊"
    },
    {
        "value": "Bulgaria",
        "en": "Bulgaria",
        "zh": "保加利亞"
    },
    {
        "value": "Burkina Faso",
        "en": "Burkina Faso",
        "zh": "布基納法索"
    },
    {
        "value": "Burundi",
        "en": "Burundi",
        "zh": "布隆迪"
    },
    {
        "value": "Cambodia",
        "en": "Cambodia",
        "zh": "柬埔寨"
    },
    {
        "value": "Cameroon",
        "en": "Cameroon",
        "zh": "喀麥隆"
    },
    {
        "value": "Canada",
        "en": "Canada",
        "zh": "加拿大"
    },
    {
        "value": "Cape Verde",
        "en": "Cape Verde",
        "zh": "佛得角"
    },
    {
        "value": "Central African Republic",
        "en": "Central African Republic",
        "zh": "中非共和國"
    },
    {
        "value": "Chad",
        "en": "Chad",
        "zh": "乍得"
    },
    {
        "value": "Chile",
        "en": "Chile",
        "zh": "智利"
    },
    {
        "value": "Colombia",
        "en": "Colombia",
        "zh": "哥倫比亞"
    },
    {
        "value": "Comoros",
        "en": "Comoros",
        "zh": "科摩羅"
    },
    {
        "value": "Congo (Congo-Brazzaville)",
        "en": "Congo (Congo-Brazzaville)",
        "zh": "剛果（布）"
    },
    {
        "value": "Costa Rica",
        "en": "Costa Rica",
        "zh": "哥斯達黎加"
    },
    {
        "value": "Croatia",
        "en": "Croatia",
        "zh": "克羅地亞"
    },
    {
        "value": "Cuba",
        "en": "Cuba",
        "zh": "古巴"
    },
    {
        "value": "Cyprus",
        "en": "Cyprus",
        "zh": "塞浦路斯"
    },
    {
        "value": "Czechia (Czech Republic)",
        "en": "Czechia (Czech Republic)",
        "zh": "捷克"
    },
    {
        "value": "Denmark",
        "en": "Denmark",
        "zh": "丹麥"
    },
    {
        "value": "Djibouti",
        "en": "Djibouti",
        "zh": "吉布提"
    },
    {
        "value": "Dominica",
        "en": "Dominica",
        "zh": "多米尼克"
    },
    {
        "value": "Dominican Republic",
        "en": "Dominican Republic",
        "zh": "多米尼加共和國"
    },
    {
        "value": "Ecuador",
        "en": "Ecuador",
        "zh": "厄瓜多爾"
    },
    {
        "value": "Egypt",
        "en": "Egypt",
        "zh": "埃及"
    },
    {
        "value": "El Salvador",
        "en": "El Salvador",
        "zh": "薩爾瓦多"
    },
    {
        "value": "Equatorial Guinea",
        "en": "Equatorial Guinea",
        "zh": "赤道幾內亞"
    },
    {
        "value": "Eritrea",
        "en": "Eritrea",
        "zh": "厄立特里亞"
    },
    {
        "value": "Estonia",
        "en": "Estonia",
        "zh": "愛沙尼亞"
    },
    {
        "value": "Eswatini",
        "en": "Eswatini",
        "zh": "斯威士蘭"
    },
    {
        "value": "Ethiopia",
        "en": "Ethiopia",
        "zh": "埃塞俄比亞"
    },
    {
        "value": "Fiji",
        "en": "Fiji",
        "zh": "斐濟"
    },
    {
        "value": "Finland",
        "en": "Finland",
        "zh": "芬蘭"
    },
    {
        "value": "France",
        "en": "France",
        "zh": "法國"
    },
    {
        "value": "Gabon",
        "en": "Gabon",
        "zh": "加蓬"
    },
    {
        "value": "Gambia",
        "en": "Gambia",
        "zh": "岡比亞"
    },
    {
        "value": "Georgia",
        "en": "Georgia",
        "zh": "格魯吉亞"
    },
    {
        "value": "Germany",
        "en": "Germany",
        "zh": "德國"
    },
    {
        "value": "Ghana",
        "en": "Ghana",
        "zh": "加納"
    },
    {
        "value": "Greece",
        "en": "Greece",
        "zh": "希臘"
    },
    {
        "value": "Grenada",
        "en": "Grenada",
        "zh": "格林納達"
    },
    {
        "value": "Guatemala",
        "en": "Guatemala",
        "zh": "危地馬拉"
    },
    {
        "value": "Guinea",
        "en": "Guinea",
        "zh": "幾內亞"
    },
    {
        "value": "Guinea-Bissau",
        "en": "Guinea-Bissau",
        "zh": "幾內亞比紹"
    },
    {
        "value": "Guyana",
        "en": "Guyana",
        "zh": "圭亞那"
    },
    {
        "value": "Haiti",
        "en": "Haiti",
        "zh": "海地"
    },
    {
        "value": "Honduras",
        "en": "Honduras",
        "zh": "洪都拉斯"
    },
    {
        "value": "Hungary",
        "en": "Hungary",
        "zh": "匈牙利"
    },
    {
        "value": "Iceland",
        "en": "Iceland",
        "zh": "冰島"
    },
    {
        "value": "India",
        "en": "India",
        "zh": "印度"
    },
    {
        "value": "Indonesia",
        "en": "Indonesia",
        "zh": "印度尼西亞"
    },
    {
        "value": "Iran",
        "en": "Iran",
        "zh": "伊朗"
    },
    {
        "value": "Iraq",
        "en": "Iraq",
        "zh": "伊拉克"
    },
    {
        "value": "Ireland",
        "en": "Ireland",
        "zh": "愛爾蘭"
    },
    {
        "value": "Israel",
        "en": "Israel",
        "zh": "以色列"
    },
    {
        "value": "Italy",
        "en": "Italy",
        "zh": "意大利"
    },
    {
        "value": "Ivory Coast",
        "en": "Ivory Coast",
        "zh": "科特迪瓦"
    },
    {
        "value": "Jamaica",
        "en": "Jamaica",
        "zh": "牙買加"
    },
    {
        "value": "Japan",
        "en": "Japan",
        "zh": "日本"
    },
    {
        "value": "Jordan",
        "en": "Jordan",
        "zh": "約旦"
    },
    {
        "value": "Kazakhstan",
        "en": "Kazakhstan",
        "zh": "哈薩克斯坦"
    },
    {
        "value": "Kenya",
        "en": "Kenya",
        "zh": "肯尼亞"
    },
    {
        "value": "Kiribati",
        "en": "Kiribati",
        "zh": "基里巴斯"
    },
    {
        "value": "Kuwait",
        "en": "Kuwait",
        "zh": "科威特"
    },
    {
        "value": "Kyrgyzstan",
        "en": "Kyrgyzstan",
        "zh": "吉爾吉斯斯坦"
    },
    {
        "value": "Laos",
        "en": "Laos",
        "zh": "老撾"
    },
    {
        "value": "Latvia",
        "en": "Latvia",
        "zh": "拉脫維亞"
    },
    {
        "value": "Lebanon",
        "en": "Lebanon",
        "zh": "黎巴嫩"
    },
    {
        "value": "Lesotho",
        "en": "Lesotho",
        "zh": "萊索托"
    },
    {
        "value": "Liberia",
        "en": "Liberia",
        "zh": "利比里亞"
    },
    {
        "value": "Libya",
        "en": "Libya",
        "zh": "利比亞"
    },
    {
        "value": "Liechtenstein",
        "en": "Liechtenstein",
        "zh": "列支敦士登"
    },
    {
        "value": "Lithuania",
        "en": "Lithuania",
        "zh": "立陶宛"
    },
    {
        "value": "Luxembourg",
        "en": "Luxembourg",
        "zh": "盧森堡"
    },
    {
        "value": "Madagascar",
        "en": "Madagascar",
        "zh": "馬達加斯加"
    },
    {
        "value": "Malawi",
        "en": "Malawi",
        "zh": "馬拉維"
    },
    {
        "value": "Malaysia",
        "en": "Malaysia",
        "zh": "馬來西亞"
    },
    {
        "value": "Maldives",
        "en": "Maldives",
        "zh": "馬爾代夫"
    },
    {
        "value": "Mali",
        "en": "Mali",
        "zh": "馬里"
    },
    {
        "value": "Malta",
        "en": "Malta",
        "zh": "馬耳他"
    },
    {
        "value": "Marshall Islands",
        "en": "Marshall Islands",
        "zh": "馬紹爾群島"
    },
    {
        "value": "Mauritania",
        "en": "Mauritania",
        "zh": "毛里塔尼亞"
    },
    {
        "value": "Mauritius",
        "en": "Mauritius",
        "zh": "毛里求斯"
    },
    {
        "value": "Mexico",
        "en": "Mexico",
        "zh": "墨西哥"
    },
    {
        "value": "Micronesia",
        "en": "Micronesia",
        "zh": "密克羅尼西亞"
    },
    {
        "value": "Moldova",
        "en": "Moldova",
        "zh": "摩爾多瓦"
    },
    {
        "value": "Monaco",
        "en": "Monaco",
        "zh": "摩納哥"
    },
    {
        "value": "Mongolia",
        "en": "Mongolia",
        "zh": "蒙古"
    },
    {
        "value": "Montenegro",
        "en": "Montenegro",
        "zh": "黑山"
    },
    {
        "value": "Morocco",
        "en": "Morocco",
        "zh": "摩洛哥"
    },
    {
        "value": "Mozambique",
        "en": "Mozambique",
        "zh": "莫桑比克"
    },
    {
        "value": "Myanmar",
        "en": "Myanmar",
        "zh": "緬甸"
    },
    {
        "value": "Namibia",
        "en": "Namibia",
        "zh": "納米比亞"
    },
    {
        "value": "Nauru",
        "en": "Nauru",
        "zh": "瑙魯"
    },
    {
        "value": "Nepal",
        "en": "Nepal",
        "zh": "尼泊爾"
    },
    {
        "value": "Netherlands",
        "en": "Netherlands",
        "zh": "荷蘭"
    },
    {
        "value": "New Zealand",
        "en": "New Zealand",
        "zh": "新西蘭"
    },
    {
        "value": "Nicaragua",
        "en": "Nicaragua",
        "zh": "尼加拉瓜"
    },
    {
        "value": "Niger",
        "en": "Niger",
        "zh": "尼日爾"
    },
    {
        "value": "Nigeria",
        "en": "Nigeria",
        "zh": "尼日利亞"
    },
    {
        "value": "North Korea",
        "en": "North Korea",
        "zh": "朝鮮"
    },
    {
        "value": "North Macedonia",
        "en": "North Macedonia",
        "zh": "北馬其頓"
    },
    {
        "value": "Norway",
        "en": "Norway",
        "zh": "挪威"
    },
    {
        "value": "Oman",
        "en": "Oman",
        "zh": "阿曼"
    },
    {
        "value": "Pakistan",
        "en": "Pakistan",
        "zh": "巴基斯坦"
    },
    {
        "value": "Palau",
        "en": "Palau",
        "zh": "帕勞"
    },
    {
        "value": "Panama",
        "en": "Panama",
        "zh": "巴拿馬"
    },
    {
        "value": "Papua New Guinea",
        "en": "Papua New Guinea",
        "zh": "巴布亞新幾內亞"
    },
    {
        "value": "Paraguay",
        "en": "Paraguay",
        "zh": "巴拉圭"
    },
    {
        "value": "Peru",
        "en": "Peru",
        "zh": "秘魯"
    },
    {
        "value": "Philippines",
        "en": "Philippines",
        "zh": "菲律賓"
    },
    {
        "value": "Poland",
        "en": "Poland",
        "zh": "波蘭"
    },
    {
        "value": "Portugal",
        "en": "Portugal",
        "zh": "葡萄牙"
    },
    {
        "value": "Qatar",
        "en": "Qatar",
        "zh": "卡塔爾"
    },
    {
        "value": "Romania",
        "en": "Romania",
        "zh": "羅馬尼亞"
    },
    {
        "value": "Russia",
        "en": "Russia",
        "zh": "俄羅斯"
    },
    {
        "value": "Rwanda",
        "en": "Rwanda",
        "zh": "盧旺達"
    },
    {
        "value": "Saint Kitts and Nevis",
        "en": "Saint Kitts and Nevis",
        "zh": "聖基茨和尼維斯"
    },
    {
        "value": "Saint Lucia",
        "en": "Saint Lucia",
        "zh": "聖盧西亞"
    },
    {
        "value": "Saint Vincent and the Grenadines",
        "en": "Saint Vincent and the Grenadines",
        "zh": "聖文森特和格林納丁斯"
    },
    {
        "value": "Samoa",
        "en": "Samoa",
        "zh": "薩摩亞"
    },
    {
        "value": "San Marino",
        "en": "San Marino",
        "zh": "聖馬力諾"
    },
    {
        "value": "Sao Tome and Principe",
        "en": "Sao Tome and Principe",
        "zh": "聖多美和普林西比"
    },
    {
        "value": "Saudi Arabia",
        "en": "Saudi Arabia",
        "zh": "沙特阿拉伯"
    },
    {
        "value": "Senegal",
        "en": "Senegal",
        "zh": "塞內加爾"
    },
    {
        "value": "Serbia",
        "en": "Serbia",
        "zh": "塞爾維亞"
    },
    {
        "value": "Seychelles",
        "en": "Seychelles",
        "zh": "塞舌爾"
    },
    {
        "value": "Sierra Leone",
        "en": "Sierra Leone",
        "zh": "塞拉利昂"
    },
    {
        "value": "Singapore",
        "en": "Singapore",
        "zh": "新加坡"
    },
    {
        "value": "Slovakia",
        "en": "Slovakia",
        "zh": "斯洛伐克"
    },
    {
        "value": "Slovenia",
        "en": "Slovenia",
        "zh": "斯洛文尼亞"
    },
    {
        "value": "Solomon Islands",
        "en": "Solomon Islands",
        "zh": "所羅門群島"
    },
    {
        "value": "Somalia",
        "en": "Somalia",
        "zh": "索馬里"
    },
    {
        "value": "South Africa",
        "en": "South Africa",
        "zh": "南非"
    },
    {
        "value": "South Korea",
        "en": "South Korea",
        "zh": "韓國"
    },
    {
        "value": "South Sudan",
        "en": "South Sudan",
        "zh": "南蘇丹"
    },
    {
        "value": "Spain",
        "en": "Spain",
        "zh": "西班牙"
    },
    {
        "value": "Sri Lanka",
        "en": "Sri Lanka",
        "zh": "斯里蘭卡"
    },
    {
        "value": "Sudan",
        "en": "Sudan",
        "zh": "蘇丹"
    },
    {
        "value": "Suriname",
        "en": "Suriname",
        "zh": "蘇里南"
    },
    {
        "value": "Sweden",
        "en": "Sweden",
        "zh": "瑞典"
    },
    {
        "value": "Switzerland",
        "en": "Switzerland",
        "zh": "瑞士"
    },
    {
        "value": "Syria",
        "en": "Syria",
        "zh": "敘利亞"
    },
    {
        "value": "Taiwan",
        "en": "Taiwan",
        "zh": "台灣"
    },
    {
        "value": "Tajikistan",
        "en": "Tajikistan",
        "zh": "塔吉克斯坦"
    },
    {
        "value": "Tanzania",
        "en": "Tanzania",
        "zh": "坦桑尼亞"
    },
    {
        "value": "Thailand",
        "en": "Thailand",
        "zh": "泰國"
    },
    {
        "value": "Timor-Leste",
        "en": "Timor-Leste",
        "zh": "東帝汶"
    },
    {
        "value": "Togo",
        "en": "Togo",
        "zh": "多哥"
    },
    {
        "value": "Tonga",
        "en": "Tonga",
        "zh": "湯加"
    },
    {
        "value": "Trinidad and Tobago",
        "en": "Trinidad and Tobago",
        "zh": "特立尼達和多巴哥"
    },
    {
        "value": "Tunisia",
        "en": "Tunisia",
        "zh": "突尼斯"
    },
    {
        "value": "Turkey",
        "en": "Turkey",
        "zh": "土耳其"
    },
    {
        "value": "Turkmenistan",
        "en": "Turkmenistan",
        "zh": "土庫曼斯坦"
    },
    {
        "value": "Tuvalu",
        "en": "Tuvalu",
        "zh": "圖瓦盧"
    },
    {
        "value": "Uganda",
        "en": "Uganda",
        "zh": "烏干達"
    },
    {
        "value": "Ukraine",
        "en": "Ukraine",
        "zh": "烏克蘭"
    },
    {
        "value": "United Arab Emirates",
        "en": "United Arab Emirates",
        "zh": "阿拉伯聯合酋長國"
    },
    {
        "value": "United Kingdom",
        "en": "United Kingdom",
        "zh": "英國"
    },
    {
        "value": "United States",
        "en": "United States",
        "zh": "美國"
    },
    {
        "value": "Uruguay",
        "en": "Uruguay",
        "zh": "烏拉圭"
    },
    {
        "value": "Uzbekistan",
        "en": "Uzbekistan",
        "zh": "烏茲別克斯坦"
    },
    {
        "value": "Vanuatu",
        "en": "Vanuatu",
        "zh": "瓦努阿圖"
    },
    {
        "value": "Vatican City",
        "en": "Vatican City",
        "zh": "梵蒂岡"
    },
    {
        "value": "Venezuela",
        "en": "Venezuela",
        "zh": "委內瑞拉"
    },
    {
        "value": "Vietnam",
        "en": "Vietnam",
        "zh": "越南"
    },
    {
        "value": "Yemen",
        "en": "Yemen",
        "zh": "也門"
    },
    {
        "value": "Zambia",
        "en": "Zambia",
        "zh": "贊比亞"
    },
    {
        "value": "Zimbabwe",
        "en": "Zimbabwe",
        "zh": "津巴布韋"
    }
]